/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * PG詳細レスポンス
 * @export
 * @interface GetGroup200ResponseItemsInner
 */
export interface GetGroup200ResponseItemsInner {
    /**
     * PGID
     * @type {number}
     * @memberof GetGroup200ResponseItemsInner
     */
    id: number;
    /**
     * PG名 半角英数のみ・スペース不可
     * @type {string}
     * @memberof GetGroup200ResponseItemsInner
     */
    paymentGroupName: string;
    /**
     * グループ名
     * @type {string}
     * @memberof GetGroup200ResponseItemsInner
     */
    groupName: string;
    /**
     * 会社名
     * @type {string}
     * @memberof GetGroup200ResponseItemsInner
     */
    companyName: string;
    /**
     * 会社ID
     * @type {string}
     * @memberof GetGroup200ResponseItemsInner
     */
    companyId: string;
    /**
     * 会社住所
     * @type {string}
     * @memberof GetGroup200ResponseItemsInner
     */
    companyAddress?: string;
    /**
     * 対象サービス（service_category）
     * @type {number}
     * @memberof GetGroup200ResponseItemsInner
     */
    serviceCategory?: GetGroup200ResponseItemsInnerServiceCategoryEnum | null;
    /**
     * 費目名
     * @type {string}
     * @memberof GetGroup200ResponseItemsInner
     */
    expenseItemName?: string | null;
    /**
     * 集計期間区分 1=1日〜月末 2=A: 1日〜15日,B: 16日〜月末
     * @type {number}
     * @memberof GetGroup200ResponseItemsInner
     */
    aggregationPeriodKind?: GetGroup200ResponseItemsInnerAggregationPeriodKindEnum | null;
    /**
     * 精算処理日区分 1=翌月1日 2=A: 当月16日,B: 翌月1日
     * @type {number}
     * @memberof GetGroup200ResponseItemsInner
     */
    processingPeriodKind?: GetGroup200ResponseItemsInnerProcessingPeriodKindEnum | null;
}


/**
 * @export
 */
export const GetGroup200ResponseItemsInnerServiceCategoryEnum = {
    OVERSEAS_ROAMING: 0
} as const;
export type GetGroup200ResponseItemsInnerServiceCategoryEnum = typeof GetGroup200ResponseItemsInnerServiceCategoryEnum[keyof typeof GetGroup200ResponseItemsInnerServiceCategoryEnum];

/**
 * @export
 */
export const GetGroup200ResponseItemsInnerAggregationPeriodKindEnum = {
    ONCE_MONTH: 1,
    TWICE_MONTH: 2
} as const;
export type GetGroup200ResponseItemsInnerAggregationPeriodKindEnum = typeof GetGroup200ResponseItemsInnerAggregationPeriodKindEnum[keyof typeof GetGroup200ResponseItemsInnerAggregationPeriodKindEnum];

/**
 * @export
 */
export const GetGroup200ResponseItemsInnerProcessingPeriodKindEnum = {
    ONCE_MONTH: 1,
    TWICE_MONTH: 2
} as const;
export type GetGroup200ResponseItemsInnerProcessingPeriodKindEnum = typeof GetGroup200ResponseItemsInnerProcessingPeriodKindEnum[keyof typeof GetGroup200ResponseItemsInnerProcessingPeriodKindEnum];


/**
 * Check if a given object implements the GetGroup200ResponseItemsInner interface.
 */
export function instanceOfGetGroup200ResponseItemsInner(value: object): value is GetGroup200ResponseItemsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('paymentGroupName' in value) || value['paymentGroupName'] === undefined) return false;
    if (!('groupName' in value) || value['groupName'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    return true;
}

export function GetGroup200ResponseItemsInnerFromJSON(json: any): GetGroup200ResponseItemsInner {
    return GetGroup200ResponseItemsInnerFromJSONTyped(json, false);
}

export function GetGroup200ResponseItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetGroup200ResponseItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'paymentGroupName': json['payment_group_name'],
        'groupName': json['group_name'],
        'companyName': json['company_name'],
        'companyId': json['company_id'],
        'companyAddress': json['company_address'] == null ? undefined : json['company_address'],
        'serviceCategory': json['service_category'] == null ? undefined : json['service_category'],
        'expenseItemName': json['expense_item_name'] == null ? undefined : json['expense_item_name'],
        'aggregationPeriodKind': json['aggregation_period_kind'] == null ? undefined : json['aggregation_period_kind'],
        'processingPeriodKind': json['processing_period_kind'] == null ? undefined : json['processing_period_kind'],
    };
}

export function GetGroup200ResponseItemsInnerToJSON(json: any): GetGroup200ResponseItemsInner {
    return GetGroup200ResponseItemsInnerToJSONTyped(json, false);
}

export function GetGroup200ResponseItemsInnerToJSONTyped(value?: GetGroup200ResponseItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'payment_group_name': value['paymentGroupName'],
        'group_name': value['groupName'],
        'company_name': value['companyName'],
        'company_id': value['companyId'],
        'company_address': value['companyAddress'],
        'service_category': value['serviceCategory'],
        'expense_item_name': value['expenseItemName'],
        'aggregation_period_kind': value['aggregationPeriodKind'],
        'processing_period_kind': value['processingPeriodKind'],
    };
}

